import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className"];
// референс pages/src/pages/LowCode/hocs/witnClassName.tsx
import React from 'react';
export function withClassName(WrappedComponent) {
  return function (_ref) {
    var className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/React.createElement("div", {
      className: className,
      "data-t-id": "utils-hocs"
    }, /*#__PURE__*/React.createElement(WrappedComponent, props));
  };
}